export var ContentIssueEnum;
(function (ContentIssueEnum) {
    ContentIssueEnum["ILLEGAL_VARIABLE_IN_CONTROL_VALUE"] = "ILLEGAL_VARIABLE_IN_CONTROL_VALUE";
    ContentIssueEnum["INVALID_FILTER_ARG_IN_VARIABLE"] = "INVALID_FILTER_ARG_IN_VARIABLE";
    ContentIssueEnum["MISSING_VALUE"] = "MISSING_VALUE";
    ContentIssueEnum["TIER_LIMIT_EXCEEDED"] = "TIER_LIMIT_EXCEEDED";
})(ContentIssueEnum || (ContentIssueEnum = {}));
export var IntegrationIssueEnum;
(function (IntegrationIssueEnum) {
    IntegrationIssueEnum["MISSING_INTEGRATION"] = "MISSING_INTEGRATION";
    IntegrationIssueEnum["INBOX_NOT_CONNECTED"] = "INBOX_NOT_CONNECTED";
})(IntegrationIssueEnum || (IntegrationIssueEnum = {}));
export class RuntimeIssue {
    issueType;
    variableName;
    message;
}
//# sourceMappingURL=issues.js.map